import './sub-menus.scss';
import { Link } from 'react-router-dom';
import { Dispatch, SetStateAction } from 'react';
import { TabsErrors } from '../../../dtos/error-message.dto';
import { keyboardClickable } from '../../../utils/a11y-utils';

interface SubMenusProps {
    subMenusEnum: Record<string, string>;
    activeSubMenu: string;
    setActiveSubMenu?: Dispatch<SetStateAction<any>>;
    errors?: TabsErrors;
}
export const SubMenus: React.FC<SubMenusProps> = ({ subMenusEnum, activeSubMenu, setActiveSubMenu, errors }) => {

    const renderSubMenuItem = (value: string) => {
        const buttonClass = `sub-menu ${activeSubMenu === value ? 'active' : ''}`;

        if (setActiveSubMenu) {
            const isValid = errors?.[value]?.every(field => field.isValid) ?? true;
            return (
                <span
                    key={value}
                    data-testid={`sub-menu-${value}`}
                    className={`${buttonClass}${!isValid ? ' is-not-valid' : ''}`}
                    {...keyboardClickable(() => setActiveSubMenu(value))}
                >
                    {value}
                    {!isValid && <div className={'not-valid-sign'} />}
                </span>
            );
        } else {
            return (
                <Link
                    to={value.replace(' ', '-').toLowerCase()}
                    key={value}
                    data-testid={`sub-menu-${value}`}
                    className={buttonClass}
                >
                    {value}
                </Link>
            );
        }
    };

    return <div className="sub-menu-wrapper">
        {Object.values(subMenusEnum).map(value =>
            renderSubMenuItem(value))}
    </div>;
};
